import React, {useEffect, useState} from "react";
import Text from "src/components/atoms/Text/Text";
import styles from './MultipartPhone.module.css';
import CountryList from 'country-list-with-dial-code-and-flag'


export default function MultipartPhone(props) {

  const { item, inputClassName, selectClassName, rowClassName, data, setData, error } = props
  const [selectedCountryCode, setSelectedCountryCode] = useState(data[`${item.id}_country_code`] || "+54");
  const [selectedAreaCode, setSelectedAreaCode] = useState(data[`${item.id}_area_code`] || "");
  const [selectedNumber, setSelectedNumber] = useState(data[`${item.id}_number`] || "");

  useEffect(() => {
    setSelectedCountryCode(data[`${item.id}_country_code`] || "+54");
    setSelectedAreaCode(data[`${item.id}_area_code`] || "");
    setSelectedNumber(data[`${item.id}_number`] || "");
  }, [data]);


  useEffect(() => {
    setData({
      ...data,
      [`${item.id}_country_code`]: selectedCountryCode,
      [`${item.id}_area_code`]: selectedAreaCode,
      [`${item.id}_number`]: selectedNumber
    });
  }, [selectedCountryCode,selectedAreaCode, selectedNumber]);

  return (
    <div className="mb-3">
      <Text weight="regular" margin={item?.labelMargin}>
        {item.label}
      </Text>
      
      <div className={styles.container}>
        <div className={[rowClassName,styles.row].join(" ")}>
          <select
            id={`${item.id}_country_code`}
            name={`${item.id}_country_code`}
            className={selectClassName}
            aria-label=".form-select-lg example"
            onChange={(e) => {setSelectedCountryCode(e.target.value)}}
          >
            {CountryList.getAll().map((country, i) => {
              return(
                <option
                  id={`country-${country.code}`}
                  value={country.dial_code}
                  key={i}
                  selected={country.dial_code == selectedCountryCode}
                >
                  {country.flag} {country.dial_code} 
                </option>
              )}
            )}
          </select>
          <input
            type="text"
            id={`${item.id}_area_code`}
            placeholder={"Código de área"}
            className={inputClassName}
            name={`${item.id}_area_code`}
            onChange={(e)=> {setSelectedAreaCode(e.target.value)}}
            value={selectedAreaCode}
          />
          <input
            type="text"
            id={`${item.id}_number`}
            placeholder={"Número de teléfono"}
            className={inputClassName}
            name={`${item.id}_number`}
            onChange={(e)=> {setSelectedNumber(e.target.value)}}
            value={selectedNumber}
          />
        </div> 
      </div>
    </div>
  );
}
